import { skipToken, useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";

import { useTRPC } from "./trpc";

/**
 * The route's tenant's name (`tenant.get`, the query the tenant chrome already runs); "" while
 * loading or outside a tenant. A storefront with no display name of its own goes by it.
 */
export function useTenantName(): string {
  const trpc = useTRPC();
  const { tenantId } = useParams({ strict: false }) as { tenantId?: string };
  const tenant = useQuery(trpc.tenant.get.queryOptions(tenantId ? undefined : skipToken));
  return tenant.data?.name ?? "";
}
